import React from 'react';
import Logo from '../../../../images/eyes-white.png';
import history from '../../../../tools/history';
import './AppLogo.scss';

const url = window.location.href;

const navigateToHome = () => {
  history.push('/');
};

const AppLogo = () => (
  <div className="logo-container">
    {url.indexOf('captioner/') >= 0 ? (
      <>
        <img className="logo" src={Logo} alt="AccessLoop Logo" />
      </>
    ) :
    (
      <>
        <button className="logo-home-button" onClick={() => navigateToHome()}>
          <img className="logo" src={Logo} alt="AccessLoop Logo" />
        </button>
      </>
    )}
  </div>
);

export default AppLogo;